import React from 'react';
import mealPlaner from '../swiper/mealPlaner';
import MealPlaner from '../swiper/mealPlaner'

export default function ({ highlightsfeed, eleRef }) {
    return (

        <section className="main_container_block_feeds">
        <div className="main_block_container_feed">
           <div className="block_container_feed_heading_text R15_61">
              {highlightsfeed.title}
            </div>
            <div className="content-div-box-artical">
                <div className="meal_planner_healthy_co">
                <div className="meal_planner_div_main"> 
                   <div className="meal_planner_healthy"> 
                      <div className="meal_planner_healthy_content"> 
                         <div className="meal_planner_healthy_content_text"> 
                            <span className="R20_75"> Eat</span>
                            <span className="B20_42"> Healthy</span>
                         </div>
                         <div className="meal_planner_healthy_content_text"> 
                            <span className="R20_75"> Live</span>
                            <span className="B20_42"> Long</span>
                         </div>
                         <div className="meal_planner_healthy_content_text"> 
                            <span className="R20_75"> Live</span>
                            <span className="B20_42"> Strong </span>
                         </div>
                      </div>
                      <div className="meal_planner_healthy_bg_pic"> 
                         <img src={highlightsfeed.backgroundImg ? highlightsfeed.backgroundImg : ''} alt="logo"/>
                      </div>
                   </div>
                   </div>
                </div>
                <div className="meal_planner_slider_view ">
                    <MealPlaner page={"dr-carousel-unit"} data={highlightsfeed.data && highlightsfeed.data[0] ? highlightsfeed.data[0].mealTypedata:[]} /> 
                </div>
                <div className="meal_planner_semolina_view">
                    <div className="planner_semolina_view"> 
                        <div className="planner_div_left_feed">
                           <div className="meal_opacity_main"> 
                           <img src={highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].recImg ? highlightsfeed.childMealData[0].recImg : "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"} alt="" onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"}}/>
                           
                           </div>
                           <div className="meal_planer_over_text R12_white">{highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].regionname ? highlightsfeed.childMealData[0].regionname : ''}</div>
                           <div className="meal_planer_over_count1">{highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].ratingpercentcount ? highlightsfeed.childMealData[0].ratingpercentcount : ''}</div>
                           <div className="meal_planer_over_green"> </div>
                        </div>
                        <div className="planner_div_left_feed"> 
                           <div className="meal_planer__right_upma"> 
                             <div className="mr_b12">
                               <h2 className="M14_42">{highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].recName ? highlightsfeed.childMealData[0].recName : ''}</h2>
                               <p className="R12_75">{highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].recDescription ? highlightsfeed.childMealData[0].recDescription : ''}</p>
                             </div>
                              <div className="mr_b10 R12_75">
                               <span className="M14_42"> Allegen info : </span>
                               {highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].seasonName ? highlightsfeed.childMealData[0].allergenInfo : ''}
                             </div>
                              <div className="meal_planner_section_common mr_b12">
                               <div className="meal_planner_section_left  R12_75"> 
                               <span className='M14_42'>Season :</span> {highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].seasonName ? highlightsfeed.childMealData[0].seasonName : ''} </div>
                               <div className="meal_planner_section_right">  
                               
                              {highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].isBookmarked?
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/bookmark.png" alt="Bookmark" title="Bookmark"/>
                              :
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/unbookmark.png" alt="Unbookmark Icon" title="Unbookmark Icon"/>
                              }                               
                               </div>
                             </div>
                           </div>
                          
                        </div>
                    </div>

                </div>
                    <div className="baby-week-social-view meal_planner_healthy_social bottom_meal_border-after"> 
                        <div className="post-options">
                           <div>
                          <div className="icon left devMemoLike font-sizeview" data-icon-font="$"> <span className="icons-text R13_61"> {highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].viewcount ? highlightsfeed.childMealData[0].viewcount : '0'}</span> </div>
                          <div className="icon left" >
                             <span className='icon likesIcon gtm-meal-like' data-icon-font=""></span>
                              <span className="icons-text R13_61"> {highlightsfeed.childMealData && highlightsfeed.childMealData[0] && highlightsfeed.childMealData[0].likeCount ? highlightsfeed.childMealData[0].likeCount : '0'} </span> </div>
                          </div>
                          <div className="icon left m-abuse-main right"> 
                            <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                            <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className="icons-text icons-text_top_meal R13_61 cursor-pointer gtm-meal-share"> Share </span></div>
                          </div>
                        </div>
                    </div>
                    <div className="btn_group_join_common btn-common-my-20 desktop_442">
                     <a href='https://parenting.firstcry.com/tools/baby-meal-plan/'>
                      <button className="M16_white gtm-meal-explore" type="button">EXPLORE MORE RECIPES</button>
                     </a>
                    </div>
            </div>
        </div>
        </section>

    )
}
